import React from 'react'
import ReportsHeader from './ReportsHeader'
import ReportsInner from './ReportsInner'

function ReportsController() {
  return (
    <React.Fragment>
      <ReportsHeader />
      <ReportsInner />
    </React.Fragment>
  )
}

export default React.memo(ReportsController)
